import styled from 'styled-components';
import {getSpacing, getFontSize, ButtonStyled} from '@tickchak/react-share/app';
import {dFlex, dFlexColumn, dFlexEnd, flexColumn, flexWrap, alignCenter} from '../../globalVariables/GlobalFlex';
import {mobileMedia, TURQUISE_BLUE} from '../../globalVariables/GlobalVariables';
import {checkmark} from '../radioBtn/RadioBtn.css';

export const content = styled.div`
    ${dFlexColumn}
    gap: ${getSpacing('spaceXl')};
    padding: ${getSpacing('spaceXl')};
    width: 100%;
    height: 100%;
    box-sizing: border-box;
`;

export const message = styled.div`
    font-size: ${getFontSize('body')};
    line-height: 1.5;
    color: var(--color-text-default);
`;

export const question = styled.div`
    font-size: ${getFontSize('body')};
    font-weight: 600;
    color: var(--color-text-default);
    margin-top: ${getSpacing('spaceSm')};
`;

export const optionText = styled.span`
    font-size: ${getFontSize('body')};
    color: var(--color-text-default);
    line-height: 1.4;
`;

export const optionItem = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: ${getSpacing('spaceSm')};
    cursor: pointer;

    ${checkmark} {
        pointer-events: none;
    }

    input:checked ~ ${checkmark} {
        background-color: ${TURQUISE_BLUE};
    }
`;

export const buttonsWrapper = styled.div`
    ${dFlexEnd}
    ${flexWrap}
    gap: ${getSpacing('spaceSm')};
    margin-top: auto;

    ${ButtonStyled.StyledButton} {
        white-space: nowrap;
    }

    ${mobileMedia} {
        ${flexColumn}
        gap: ${getSpacing('spaceSm')};

        ${ButtonStyled.StyledButton} {
            width: 100%;
        }
    }
`;

